class FavoritesContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"name": "sampleHash",
				"type": "bytes32"
			}
		],
		"name": "favoriteSample",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "sampleHash",
				"type": "bytes32"
			}
		],
		"name": "unfavoriteSample",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"name": "sampleHash",
				"type": "bytes32"
			}
		],
		"name": "SampleFavorited",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"name": "sampleHash",
				"type": "bytes32"
			}
		],
		"name": "SampleUnfavorited",
		"type": "event"
	}
        ];
        
        this.contractAddress = '0xcddbc9238e5ba4f6f4c0c8e0ef4231e1be4943fc';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}
	

export default FavoritesContract;
